import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function getMySchedule(start, end) {
    const params = new URLSearchParams({ start, end });
    const response = await apiFetch(`${API_ENDPOINTS.SCHEDULE_MY}?${params}`, { method: "GET" });
    if (!response.ok) throw new Error("Greška pri dohvaćanju rasporeda");
    return response.json();
}

export async function getWeekSchedule(start, end) {
    const params = new URLSearchParams({ start, end });
    const response = await apiFetch(`${API_ENDPOINTS.SCHEDULE}?${params}`, { method: "GET" });
    if (!response.ok) throw new Error("Greška pri dohvaćanju rasporeda");
    return response.json();
}

export async function addShift(shiftData) {
    const response = await apiFetch(API_ENDPOINTS.SCHEDULE, {
        method: "POST",
        body: JSON.stringify(shiftData),
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri dodavanju smjene");
    }
    return response.json();
}

export async function updateShift(id, shiftData) {
    const response = await apiFetch(`${API_ENDPOINTS.SCHEDULE}/${id}`, {
        method: "PUT",
        body: JSON.stringify(shiftData),
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri ažuriranju smjene");
    }
    return response.json();
}

export async function deleteShift(id) {
    const response = await apiFetch(`${API_ENDPOINTS.SCHEDULE}/${id}`, { method: "DELETE" });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri brisanju smjene");
    }
}
